"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMakeStyles = void 0;
require("./tools/Object.fromEntries");
const objectKeys_1 = require("./tools/objectKeys");
/**
 * @see {@link https://github.com/garronej/tss-react}
 */
function createMakeStyles(params) {
    const { useTheme, useCssAndCx } = params;
    /** returns useStyle. */
    function makeStyles() {
        return function (getCssObjectOrCssObject) {
            const getCssObject = typeof getCssObjectOrCssObject === "function"
                ? getCssObjectOrCssObject
                : () => getCssObjectOrCssObject;
            function useStyles(params) {
                const theme = useTheme();
                const { css, cx } = useCssAndCx();
                const cssObject = getCssObject(theme, params);
                const classes = Object.fromEntries(objectKeys_1.objectKeys(cssObject).map(key => [
                    key,
                    css(cssObject[key]),
                ]));
                return {
                    classes,
                    theme,
                    css,
                    cx,
                };
            }
            return useStyles;
        };
    }
    return { makeStyles };
}
exports.createMakeStyles = createMakeStyles;
//# sourceMappingURL=createMakeStyles.js.map